export default function Step4() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
                d="M19.9999 24.5502C26.0073 24.5502 30.8773 19.9226 30.8773 14.2142V2.79541H9.12256V14.2142C9.12256 19.9226 13.9925 24.5502 19.9999 24.5502Z"
                stroke="white"
                strokeWidth="1.45032"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.12262 15.8481V7.14624H2.59619C2.59619 12.9475 5.8594 15.8481 9.12262 15.8481Z"
                stroke="white"
                strokeWidth="1.45032"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.8774 15.8481V7.14624H37.4039C37.4039 12.9475 34.1407 15.8481 30.8774 15.8481Z"
                stroke="white"
                strokeWidth="1.45032"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M20 25.2751L20 31.8016" stroke="white" strokeWidth="1.45032" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.2979 36.8778L15.0143 32.5269H25.441L29.4268 36.8778H11.2979Z" stroke="white" strokeWidth="1.45032" strokeLinejoin="round" />
            <path
                d="M19.9999 7.87134L21.2786 10.4623L24.1379 10.8778L22.0689 12.8945L22.5573 15.7423L19.9999 14.3978L17.4425 15.7423L17.9309 12.8945L15.8619 10.8778L18.7212 10.4623L19.9999 7.87134Z"
                fill="white"
            />
        </svg>
    );
}
